import { Area } from '@src/main/modules/common/area/domain/Area';
import { findAreaBasedOnSubsubareaId } from '@src/main/modules/common/area/domain/methods/findAreaBasedOnSubsubareaId';
import { Dashboard } from '@src/main/modules/common/dashboard/domain/Dashboard';

export interface DashboardResponse {
  id: string;
  name: string;
  subsubareaId: string;
  artifactType: 'PowerBIReport' | 'PaginatedReport' | 'App' | 'Dashboard';
  artifactId: string;
  workspaceId?: string;
  originalName: string;
  refreshTime?: string;
  views?: number;
  syncStatus: string;
  keyTags: string[];
  tags: string[];
  description?: string;
  isCertified: boolean;
  showAll: boolean;
  createdAt: string;
  createdBy: string;
  updatedAt: string;
  updatedBy: string;
  haveAccess: boolean;
  repositoryType: string | null;
  allEmployees: boolean;
}

export const mapFromResponseToDomain = (
  dashboardsResponse: DashboardResponse[],
  areas: Area[],
): Dashboard[] =>
  dashboardsResponse.map((dashboardResponse: DashboardResponse) => ({
    id: dashboardResponse.id,
    artifactId: dashboardResponse.artifactId,
    workspaceId: dashboardResponse.workspaceId,
    name: dashboardResponse.name,
    area: findAreaBasedOnSubsubareaId(dashboardResponse.subsubareaId, areas),
    artifactType: dashboardResponse.artifactType,
    originalName: dashboardResponse.originalName,
    keyTags: dashboardResponse.keyTags,
    tags: dashboardResponse.tags,
    description: dashboardResponse.description,
    isCertified: dashboardResponse.isCertified,
    isShowAll: dashboardResponse.showAll,
    refreshDate: dashboardResponse.refreshTime
      ? new Date(Date.parse(dashboardResponse.refreshTime))
      : undefined,
    views: dashboardResponse.views,
    syncStatus: dashboardResponse.syncStatus,
    createdAt: new Date(Date.parse(dashboardResponse.createdAt)),
    createdBy: dashboardResponse.createdBy,
    updatedAt: new Date(Date.parse(dashboardResponse.updatedAt)),
    updatedBy: dashboardResponse.updatedBy,
    haveAccess: dashboardResponse.haveAccess,
    repositoryType: dashboardResponse.repositoryType,
    allEmployees: dashboardResponse.allEmployees,
  }));
